import { orchestrator } from "satcheljs";
import closeAddinPane from "owa-addins-store/lib/actions/closeAddinPane";
import terminateTaskPaneAddinCommand from "owa-addins-store/lib/actions/terminateTaskPaneAddinCommand";
import type TaskPaneType from "owa-addins-store/lib/store/schema/TaskPaneType";
import getDrawerPaneId from "owa-app-pane-group-utils/lib/getDrawerPaneId";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import { flexPaneOpened } from "owa-suite-header-apis";
import { getPinnablePaneByFlexPaneId } from "../utils/getPinnablePaneRegistrations";
import { isPanePinningEnabled } from "../utils/isPanePinningEnabled";
import { savePinnedPaneSetting } from "../utils/savePinnedPaneSetting";
import { isCopilotChatDrawerShown } from "owa-copilot-chat-drawer-store";
import { isCapabilityEnabled } from "owa-capabilities";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { addinsUseDrawerPaneInpopoutsCapability } from "owa-capabilities-definitions/lib/addinsUseDrawerPaneInpopoutsCapability";
import { getAddinMailboxInfoForWindow } from "owa-addins-view/lib/utils/getAddinMailboxInfoForWindow";
import isPopout from "owa-popout-v2/lib/utils/isPopout";

// if opened flex pane is a pinnable pane, silently mark the pane as pinned in user settings
orchestrator(flexPaneOpened, ({ flexPaneId, targetWindow }) => {
    if (!isPanePinningEnabled()) {
        return;
    }
    
    const pinnablePane = getPinnablePaneByFlexPaneId(flexPaneId);
    if (!!pinnablePane && !isCopilotChatDrawerShown()) {
        // If the Chat Drawer is opened, and because FlexPanes can render next
        // to it, we want to prioritize the Chat Drawer on next sticky open,
        // thus we do not want to override with saving a new pinned pane setting.
        savePinnedPaneSetting(pinnablePane);
    }
    
    // AddinsPane is the id of the pane in the suite header.
    // getDrawerPaneId('addins') is the id of the pane in the new header implementation.
    if (flexPaneId != "AddinsPane" && flexPaneId != getDrawerPaneId("addins")) {
        if (isCapabilityEnabled(addinsUseDrawerPaneInpopoutsCapability)) {
            const mailboxInfo = isPopout(targetWindow ?? window)
                ? (getAddinMailboxInfoForWindow(targetWindow ?? window) ??
                    getGlobalSettingsAccountMailboxInfo())
                : getGlobalSettingsAccountMailboxInfo();
            terminateTaskPaneAddinCommand("Persistent", targetWindow ?? window, mailboxInfo);
            terminateTaskPaneAddinCommand("NonPersistent", targetWindow ?? window, mailboxInfo);
            closeAddinPane(mailboxInfo, targetWindow ?? window, true /*isNewFlexPaneOpened*/);
        }
        else {
            // We are using getModuleContextMailboxInfo() here as this will get called only from the main window.
            // The popped out windows and calendar do not have flexPane.
            const mailboxInfo = getModuleContextMailboxInfo();
            terminateTaskPaneAddinCommand("Persistent", window, mailboxInfo);
            terminateTaskPaneAddinCommand("NonPersistent", window, mailboxInfo);
            closeAddinPane(mailboxInfo, window, true);
        }
    }
});
